import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  ModalInterface,
  removeAllModal,
  removeModal,
} from "../../../libraries/state_reducers/widget/ModalsReducer";
import { IconNormal } from "./Icon";
import AppTheme from "../../../service/app_config/AppTheme";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import ModalKeys from "../../../const/ModalKeys";
import HomeCallBody from "../../../screens/home/widget/HomeCallBody";
import ProductsContent from "../../../screens/products/ProductsContent";
import HomeSocialBody from "../../../screens/home/widget/HomeSocialBody";
import EmailContent from "../../../screens/email/EmailContent";
import { ResponsiveDeviceType } from "../../layouts/ScreenMedia";
import BranchDeptChatsContent from "../../../screens/branch/branch_dept_chats/BranchDeptChatsContent";
import BranchTeamContent from "../../../screens/branch/branch_team/BranchTeamContent";
import BranchGroupsContent from "../../../screens/branch/branch_groups/BranchGroupsContent";
import SettingsLanguage from "../../../screens/settings/settings/widget/SettingsLanguage";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import ImageDocumentPreviewContent from "../../../screens/preview/image_document_preview/ImageDocumentPreviewContent";
import DeactivateAccountAskPasswordAlert from "../../../screens/deactivate_account/deactivate_account_reason/widget/DeactivateAccountAskPasswordAlert";
import DeactivateAccountSuccessAlert from "../../../screens/deactivate_account/deactivate_account_reason/widget/DeactivateAccountSuccessAlert";
import CountryCodeAlert from "../../../screens/country_code/widget/CountryCodeAlert";
import CountryStateCityAreaAlert from "../../../screens/country_state_city_area/country_state_city_area/CountryStateCityAreaAlert";
import GeoAlert from "../../../screens/country_state_city_area/geo_alert/GeoAlert";
import { routeName as routeNameSearch } from "../../../screens/search/SearchScreen";
import SignupWelcomeAlert from "../../../screens/onboarding/signup/widget/SignupWelcomeAlert";
import DetailConnectDeptTeam from "../../screens/detail_connect_dept_team/DetailConnectDeptTeam";
import WorkProfileAlert from "../../../screens/work_profile/work_profile/WorkProfileAlert";
import HomeGuestUserCallBody from "../../../screens/home_guest_user/guest_home/widget/HomeGuestUserCallBody";
import HomeGuestUserSocialBody from "../../../screens/home_guest_user/guest_home/widget/HomeGuestUserSocialBody";
import GuestUserFormContent from "../../../screens/home_guest_user/guest_user_form/GuestUserFormContent";
import MyMessagesContent from "../../../screens/work_profile/my_mesasges/MyMessagesContent";
import AutomatedReplyContent from "../../../screens/work_profile/automated_reply/AutomatedReplyContent";
import DatePickerAlert from "./DatePickerAlert";
import { isMobile } from "react-device-detect";
import ConversationMuteNotificationAlert from "../../../screens/chats/widget/chat_alerts/ConversationMuteNotificationAlert";
import ConversationReportAlert from "../../../screens/chats/widget/chat_alerts/ConversationReportAlert";
import ConversationGroupExitAlert from "../../../screens/chats/widget/chat_alerts/ConversationGroupExitAlert";
import ImageEditorScreen from "../../../service/image_editor/ImageEdiorScreen";
import DetailConnectGroup from "../../screens/detail_connect_dept_team/DetailConnectGroup";
import WebViewScreen from "../../../screens/webview/WebViewScreen";
import FileDocumentPickerScreen from "../../../service/file_picker/FileDocumentPickerScreen";
import ARFScreen from "../../../screens/chats/ARF/ARFScreen";
import Div from "./Div";
import DetailConnectDepartment from "../../screens/detail_connect_dept_team/DetailConnectDepartment";
import ChatLocationScreen from "../../../screens/chats/chat_location/ChatLocationScreen";
import ConversationDeleteConfirmAlert from "../../../screens/chats/widget/chat_conversation/ConversationDeleteConfirmAlert";
import ForwardChatScreen from "../../../screens/chats/forward_chat/ForwardChatScreen";
import ChatMediaScreen from "../../../screens/chats/chat_media/ChatMediaScreen";
import GroupChatInfoScreen from "../../../screens/chats/group_chat_info/GroupChatInfoScreen";
import ConversationMediaDeleteConfirmAlert from "../../../screens/chats/widget/chat_conversation/ConversationMediaDeleteConfirmAlert";
import CameraCaptureScreen from "../../../service/camera/CameraCaptureScreen";
import ImageDocumentPreviewScreen from "../../../screens/preview/image_document_preview/ImageDocumentPreviewScreen";
import VideoTrimmerScreen from "../../../service/video_trimmer/VideoTrimmerScreen";
import BranchListScreen from "../../../screens/branch/branch_list/BranchListScreen";
import DivisionsScreen from "../../../screens/divisions/DivisionsScreen";

const Modals = () => {
  const dispatch = useDispatch();
  const IS_DEBUG = process.env.NODE_ENV;

  const type: number = ResponsiveDeviceType();
  const modals = useSelector((state: RootState) => state.modals.list);

  //
  const modalBody = (modalDetail: ModalInterface): any => {
    const modalId: string = modalDetail.id;
    const screenMobileView: boolean | undefined = modalDetail.screenMobileView;

    if (modalId === ModalKeys.home_email_modal) {
      return <EmailContent isModal={true} />;
    } else if (modalId === ModalKeys.home_products_modal) {
      return <ProductsContent isModal={true} />;
    } else if (modalId === ModalKeys.home_call_modal) {
      return <HomeCallBody />;
    } else if (modalId === ModalKeys.home_guest_call_modal) {
      return <HomeGuestUserCallBody />;
    } else if (modalId === ModalKeys.home_social_list_modal) {
      return <HomeSocialBody />;
    } else if (modalId === ModalKeys.home_guest_social_list_modal) {
      return <HomeGuestUserSocialBody />;
    } else if (modalId === ModalKeys.home_dept_chat_modal) {
      return <BranchDeptChatsContent isModal={true} />;
    } else if (modalId === ModalKeys.home_team_modal) {
      return <BranchTeamContent isModal={true} />;
    } else if (modalId === ModalKeys.home_groups_modal) {
      return <BranchGroupsContent isModal={true} />;
    } else if (modalId === ModalKeys.settings_language) {
      return <SettingsLanguage />;
    } else if (modalId === ModalKeys.list_choose_branch) {
      return <BranchListScreen screenMobileView={screenMobileView!} />;
    } else if (modalId === ModalKeys.preview_image_document) {
      return <ImageDocumentPreviewContent isModal={true} />;
    } else if (modalId === ModalKeys.deactivation_confirm_ask_password) {
      return <DeactivateAccountAskPasswordAlert />;
    } else if (modalId === ModalKeys.deactivation_success_alert) {
      return <DeactivateAccountSuccessAlert />;
    } else if (modalId === ModalKeys.country_code_selection) {
      return <CountryCodeAlert />;
    } else if (
      [ModalKeys.choose_city_of_residence, ModalKeys.search_filter].includes(
        modalId
      )
    ) {
      return (
        <CountryStateCityAreaAlert
          screenName={
            modalId === ModalKeys.search_filter ? routeNameSearch : ""
          }
        />
      );
    } else if (modalId === ModalKeys.choose_country_state_city_area) {
      return <GeoAlert />;
    } else if (modalId === ModalKeys.signup_welcom_message) {
      return <SignupWelcomeAlert />;
    } else if (
      [
        ModalKeys.connect_detail_branch_depts_chat,
        ModalKeys.connect_detail_branch_team,
      ].includes(modalId)
    ) {
      return <DetailConnectDeptTeam modalId={modalId} />;
    } else if (modalId === ModalKeys.work_profile_menu) {
      return <WorkProfileAlert />;
    } else if (
      [
        ModalKeys.home_guest_general_form,
        ModalKeys.home_guest_feedback_form,
      ].includes(modalId)
    ) {
      return <GuestUserFormContent isModal={true} />;
    } else if (modalId === ModalKeys.work_my_messages) {
      return <MyMessagesContent isModal={true} />;
    } else if (modalId === ModalKeys.work_automated_reply) {
      return <AutomatedReplyContent isModal={true} />;
    } else if (modalId === ModalKeys.datepicker) {
      return <DatePickerAlert />;
    } else if (modalId === ModalKeys.chat_mute_notification) {
      return <ConversationMuteNotificationAlert />;
    } else if (modalId === ModalKeys.chat_report) {
      return <ConversationReportAlert />;
    } else if (modalId === ModalKeys.chat_work_my_messages) {
      return <MyMessagesContent isModal={true} fromChat={true} />;
    } else if (modalId === ModalKeys.chat_group_exit) {
      return <ConversationGroupExitAlert />;
    } else if (modalId === ModalKeys.image_editor) {
      return <ImageEditorScreen screenMobileView={screenMobileView!} />;
    } else if (modalId === ModalKeys.connect_detail_branch_group) {
      return <DetailConnectGroup />;
    } else if (modalId === ModalKeys.web_view) {
      return (
        <WebViewScreen
          title={modalDetail.title!}
          url={modalDetail.webViewUrl!}
        />
      );
    } else if (modalId === ModalKeys.file_document_viewer) {
      return <FileDocumentPickerScreen screenMobileView={screenMobileView!} />;
    } else if (modalId === ModalKeys.arf_form) {
      return <ARFScreen screenMobileView={screenMobileView!} />;
    } else if (modalId === ModalKeys.connect_detail_branch_depts_restrict) {
      return <DetailConnectDepartment />;
    } else if (modalId === ModalKeys.chat_location) {
      return <ChatLocationScreen screenMobileView={screenMobileView!} />;
    } else if (modalId === ModalKeys.chat_delete_message) {
      return <ConversationDeleteConfirmAlert />;
    } else if (modalId === ModalKeys.chat_forward) {
      return (
        <ForwardChatScreen
          screenMobileView={screenMobileView!}
          isMedia={false}
        />
      );
    } else if (modalId === ModalKeys.chat_media) {
      return <ChatMediaScreen />;
    } else if (modalId === ModalKeys.chat_group_info) {
      return <GroupChatInfoScreen />;
    } else if (modalId === ModalKeys.chat_delete_message_media) {
      return <ConversationMediaDeleteConfirmAlert />;
    } else if (modalId === ModalKeys.chat_forward_media) {
      return (
        <ForwardChatScreen
          screenMobileView={screenMobileView!}
          isMedia={true}
        />
      );
    } else if (modalId === ModalKeys.chat_camera) {
      return <CameraCaptureScreen screenMobileView={screenMobileView!} />;
    } else if (modalId === ModalKeys.chat_preview_image_document) {
      return (
        <ImageDocumentPreviewScreen screenMobileView={screenMobileView!} />
      );
    } else if (modalId === ModalKeys.video_editor) {
      return <VideoTrimmerScreen screenMobileView={screenMobileView!} />;
    } else if (modalId === ModalKeys.list_choose_division) {
      return <DivisionsScreen screenMobileView={screenMobileView!} />;
    }

    return;
  };

  const isBottomSheet = (sheetStatus: boolean = false) => {
    if (type !== 3 && sheetStatus) {
      return true;
    }
    return false;
  };

  const handleResize = () => {
    if (IS_DEBUG === "production" && !isMobile) {
      dispatch(removeAllModal());
    }
  };

  const closeModal = (id: string) => {
    if (UtilityHelper.isNotEmpty(id)) {
      dispatch(removeModal(id));
      //if (isMobile) {
      if (modals.length === 1) {
        const lastModal: ModalInterface = modals[modals.length - 1];
        if ((lastModal.screenMobileView ?? false) === true) {
          window.history.back();
        }
        // window.history.replaceState(null, "", window.location.pathname);
      }
      //}
    }
  };

  const handlePopState = (event: PopStateEvent) => {
    console.log(`hash: ${window.location.hash}`);
    console.log(`href: ${window.location.href}`);
    console.log(`path: ${window.location.pathname}`);
    console.log(`modal length: ${modals.length}`);

    if (modals.length > 0) {
      const lastModal: ModalInterface = modals[modals.length - 1];
      if (!window.location.hash.includes(`#${lastModal.id}`)) {
        dispatch(removeModal(lastModal.id));
      }
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (type < 3) {
      if (modals.length === 1) {
        const lastModal: ModalInterface = modals[modals.length - 1];
        if ((lastModal.screenMobileView ?? false) === true) {
          window.history.pushState(null, "", `#${lastModal.id}`);
          //window.history.replaceState(null, "", `#${lastModal.id}`);
          window.addEventListener("popstate", handlePopState);
          return () => {
            window.removeEventListener("popstate", handlePopState);
          };
        }
      }
    }
    // eslint-disable-next-line
  }, [modals]);

  return (
    <>
      {modals.map((modal, index) =>
        (modal.screenMobileView ?? false) && type < 3 ? (
          <Modal
            key={index}
            show={true}
            animation={false}
            backdrop="static"
            keyboard={false}
            centered={true}
            size="lg"
            fullscreen={true}
          >
            <Modal.Body className="p-0 m-0">{modalBody(modal)}</Modal.Body>
          </Modal>
        ) : (
          <Modal
            key={index}
            show={true}
            onHide={() => closeModal(modal.id)}
            animation={false}
            backdrop={modal.static ? "static" : undefined}
            keyboard={!modal.static}
            centered={true}
            size={
              modal.size === undefined
                ? "lg"
                : modal.size === "md"
                ? undefined
                : modal.size
            }
            fullscreen={
              isBottomSheet(modal.allowBottomSheet) ? true : undefined
            }
            dialogClassName={
              isBottomSheet(modal.allowBottomSheet) ? "bottom-sheet" : ""
            }
            contentClassName={
              modal.id === ModalKeys.work_profile_menu ? "bgcolor-primary" : ""
            }
            className={`dialog-${index}`}
            backdropClassName={`backdrop-${index}`}
          >
            {!isBottomSheet(modal.allowBottomSheet) && !modal.hideHeader && (
              <Modal.Header className="border-0">
                <Modal.Title
                  className={`${
                    modal.id === ModalKeys.work_profile_menu
                      ? "text-left  color-white ps-4"
                      : "text-center  color-theme-label "
                  }  w-100 font-size-20_21 font-gotham-bold pt-3`}
                >
                  {modal.title !== undefined &&
                    AppTranslation.text(modal.title)}
                </Modal.Title>

                {!(modal.static ?? false) && (
                  <IconNormal
                    name="close"
                    className="btn-close"
                    color={
                      modal.id === ModalKeys.work_profile_menu
                        ? AppTheme.white
                        : AppTheme.primary
                    }
                    size={24}
                    handleClick={() => closeModal(modal.id)}
                  />
                )}
              </Modal.Header>
            )}

            {isBottomSheet(modal.allowBottomSheet) &&
              !modal.bottomSheetHideTitle && (
                <Modal.Header className="border-0 pb-1 pb-md-3">
                  <Modal.Title
                    className={`w-100 font-size-20_21 font-gotham-bold color-theme-label ${
                      (modal.titleCenter ?? false) === true ? "text-center" : ""
                    }`}
                  >
                    {modal.title !== undefined &&
                      AppTranslation.text(modal.title)}
                  </Modal.Title>
                </Modal.Header>
              )}

            <Modal.Body
              className={`px-${
                isBottomSheet(modal.allowBottomSheet) ? "3" : "4"
              } px-lg-5  ${
                UtilityHelper.isNotEmpty(modal.title!) ? " pt-2" : ""
              } pb-${isBottomSheet(modal.allowBottomSheet) ? "3" : "5"}`}
            >
              {modalBody(modal)}
            </Modal.Body>
          </Modal>
        )
      )}
    </>
  );
};

export default Modals;

export const ModalTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Div className=" w-100 font-size-20_21 font-gotham-bold color-theme-label">
      {children}
    </Div>
  );
};
